import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index";
import AppLayout from "@/layouts/AppLayout";
import AuthLayout from "@/layouts/AuthLayout";

import Dashboard from "../views/Dashboard.vue";

import Customers from "../views/Customers.vue";
import CustomerHistory from "../views/Customers/CustomerHistory.vue";

import Transactions from "../views/Transactions.vue";
import TransactionDetails from "../views/Transaction/Details.vue";

import Login from "../views/Auth/Login.vue";

const routes = [
  {
    path: "/",
    name: "App",
    component: AppLayout,
    meta: { authorize: ["Manager", "User"] },
    redirect: "dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: { authorize: ["Manager", "User"] },
        component: Dashboard,
      },
      {
        path: "customer",
        name: "Customers",
        meta: { authorize: ["Manager", "User"] },
        component: Customers,
        children: [
          {
            path: ":id",
            name: "Customer History",
            component: CustomerHistory,
          },
        ],
      },
      {
        path: "transactions",
        name: "Transactions",
        meta: { authorize: ["Manager", "User"] },
        component: Transactions,
        children: [
          {
            path: ":id",
            name: "Transaction Details",
            component: TransactionDetails,
          },
        ],
      },
    ],
  },

  {
    path: "/auth",
    name: "Auth",
    component: AuthLayout,
    redirect: "login",
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const currentUser = store.getters.getUser;
  if (authorize) {
    if (!currentUser) {
      return next({ path: "/auth/login" });
    }
    if (!authorize.includes(currentUser?.role)) {
      return next({ path: "/auth/login", query: { returnUrl: to.path } });
    }
  }
  next();
});
export default router;
